import { createListCollection } from '@chakra-ui/react';

export const polarizedListCollection = createListCollection({
	items: [
		{
			value: 'true',
			label: 'Yes',
		},
		{
			value: 'false',
			label: 'No',
		},
	],
});
